import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SelectTeamComponent } from '../select-team/select-team.component';
import { CommonService } from 'src/app/core/services/common.service';
import { TeamStoreService } from '../services/team-store.service';
import { ProductService } from 'src/app/core/services/product.service';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterServService {
  productList: any[] = []
  selectedProductList: any[] = [];
  paginatedSelectedProducts: any[] = []
  selectedStepIndex = 0;
  editStoreTab = 0;
  paginationLength: number = 0;
  artFromOrg: any[] = [];
  private baseUrl = `${environment.apiUrl}v1/`;
  selectedProdFilter = {
    paginatedProducts: [],
    totalPages: 0,
    per_page: 12,
    page: 1
  }
  filterParams = {
    markets: '',
    minPrice: 0,
    maxPrice: 500,
    name: '',
    styleName: '',
    colors: [],
    categories: [],
    sizes: [],
    brands: [],
    vendorName: [],
    filterText: '',
    per_page: 12,
    page: 1,
    categoryId: ''
  }
  artWorkUrl: any;
  addedProductCount = 0;

  constructor(private http: HttpClient, private commonService: CommonService,
    private teamServ: TeamStoreService, private productService: ProductService,
  ) {
  }

  formatFilterParams() {
    let formattedParams = {};
    //  = {
    //   name: this.filterparamsText,
    //   styleName: this.filterParams.styleName
    // }
    let tempStr = ''
    console.log(this.filterParams, 'filp');
    console.log(formattedParams, 'fil');

    tempStr = JSON.stringify(this.filterParams.colors)
    tempStr = tempStr.substr(1, tempStr.length - 2)
    formattedParams["colors"] = tempStr
    tempStr = JSON.stringify(this.filterParams.categories)
    tempStr = tempStr.substr(1, tempStr.length - 2)
    formattedParams["categories"] = tempStr
    tempStr = JSON.stringify(this.filterParams.sizes)
    tempStr = tempStr.substr(1, tempStr.length - 2)
    formattedParams["sizes"] = tempStr
    return formattedParams
  }


  generateUniqueNumber(): number {
    return Math.floor(Math.random() * 100000); // Generate a random number between 0 and 99999
  }

  // getProduct(params) {
  //   this.commonService.toggleLoading(true)

  //       return this.http
  //         .get<any>(this.baseUrl +
  //           `products?orderby=${params.orderBy || 'id'}&order=${params.order || 'asc'}&page=${params.page || '1'}` +
  //           `&per_page=${params.per_page || '0'}&category=${params.categoryId || '0'}&viewType=${params.viewType || ''}` +
  //           `&storeStatuses=${params.storeStatuses || '1'}&keyword=${params.keyword || ''}&colors=${params.color || ''}&markets=${params.markets || ''}` ,
  //           { observe: "response" })
  //         .pipe(
  //           map((response) => {
  //             this.productList = response.body.data.map((item: any,index: any) => ({
  //               ...item,
  //               mapCode: new Date().getTime() + "" + Math.floor(Math.random() * 10000 + 1),
  //               uniqueNumber: this.generateUniqueNumber(),
  //               isAdded: this.selectedProductList.some((product: any) => product.id == item.id)? 'Y' : 'N',
  //               Arts: this.artFromOrg? this.artFromOrg : []
  //             }));

  //             this.selectedProductList.forEach((selProd: any)=>{
  //               this.productList.forEach((prod: any) => {
  //                 if(selProd.id == prod.id) {
  //                 prod.uniqueNumber = selProd.uniqueNumber;
  //                 prod.mapCode = selProd.mapCode;
  //                 prod.Arts = selProd.Arts
  //                 prod['selectedArt'] = selProd.selectedArt
  //                 console.log(prod,'prd');
  //               }
  //               })
  //             })

  //                   this.productList.forEach((prod: any) => {
  //                     this.loopColorList(prod)
  //                         // if (this.addedProductCount <= 7) {
  //                         //     prod.isAdded = 'Y';
  //                         //     prod.Arts.forEach((p: any, index: any) => {
  //                         //       if(index == 0){
  //                         //         p['stat'] = true
  //                         //         prod['selectedArt'] = p.artUrl
  //                         //       }
  //                         //     });
  //                         //     this.selectedProductList.push(prod);
  //                         //     this.addedProductCount++;
  //                         // }
  //                     });
  //                   this.paginationLength = JSON.parse(response.headers.get("Pagination")).totalItems || 0
  //                   this.commonService.toggleLoading(false);
  //                 },(error) => {
  //                   this.commonService.toggleLoading(false);
  //                   this.commonService.openErrorSnackBar(error.message, "");
  //           })
  //         );
  //   }


  // FilterServService.ts
  getProduct(params: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.commonService.toggleLoading(true);

      const param = {
        categoryId: params.categoryId,
        page: params.page,
        per_page: params.per_page,
        storeStatuses: '2,3',
        keyword: params.keyword,
        orderBy: params.orderBy,
        order: params.order,
        color: params.color,
        markets: params.markets
      };

      this.productService.getStoreProductsForEndUsers(param).pipe(
        tap(response => {
          this.productList = response.body.data.map((item: any) => ({
            ...item,
            mapCode: new Date().getTime() + "" + Math.floor(Math.random() * 10000 + 1),
            uniqueNumber: this.generateUniqueNumber(),
            isAdded: this.selectedProductList.some((product: any) => product.id === item.id) ? 'Y' : 'N',
            Arts: this.artFromOrg ?? []
          }));

          this.selectedProductList.forEach((selProd: any) => {
            this.productList.forEach((prod: any) => {
              if (selProd.id === prod.id) {
                prod.uniqueNumber = selProd.uniqueNumber;
                prod.mapCode = selProd.mapCode;
                prod.Arts = selProd.Arts;
                prod['selectedArt'] = selProd.selectedArt;
              }
            });
          });

          this.productList.forEach((prod: any) => this.loopColorList(prod));
          this.paginationLength = JSON.parse(response.headers.get("Pagination")).totalItems || 0;
          this.commonService.toggleLoading(false);
          resolve();
        }),
        catchError(error => {
          this.productList = [];
          this.commonService.toggleLoading(false);
          reject(error);
          return throwError(() => error);
        })
      ).subscribe();
    });
  }



  loopColorList(product: any) {
    if (product.colorList.length > 0) {
      // Set all colors' stat to false
      product.colorList.forEach((color: any) => {
        color.stat = false;
      });

      // Select the first color and set its stat to true
      let firstColor = product.colorList[0];
      firstColor.stat = true;

      // Call the API with the first color
      this.teamServ.getProductDetails(product.id).subscribe((data: any) => {
        let imageSources = data.products.variants
          .find((clr: any) => clr.name === firstColor.name)?.images
          ?.map((src: any) => src.src) || [];

        if (imageSources.length > 0) {
          product.image = imageSources; // Update product image
        }

      });
    }
  }





}
